export class UploadDocumentItem {
    constructor(optionalOptions = {}) {
        $('.upload-button-document').on('click', function (event) {
            let idInput = $(this).attr('data-target');
            $("input[id=" + idInput + "]").click();
        });

        $('.upload-input-document').on('change', function (event) {
            let idImg = $(this).attr('id');
            let input = this;

            if (input.files && input.files[0]) {
                var fileName = input.files[0].name;
                var extension = input.files[0].name.split('.').pop().toLowerCase()

                    var documentInfo = $('.document-uploaded--info[data-target="' + idImg + '"]');

                    documentInfo.find('.document-uploaded--file span.icon').eq(0).addClass('icon-file--' + extension);
                    documentInfo.find('.document-uploaded--file .document-uploaded-file--name').eq(0).text(fileName);
                    documentInfo.show();
                    $(input).parent().find('.base-form-upload-input--wrap').first().removeClass('upload-button--empty')
            }
        });
    }

    destructor() {
    }
}

export default new UploadDocumentItem();
